import { BottomSheetModal } from '@gorhom/bottom-sheet';
import React, { RefObject } from 'react';
import { StyleSheet, View } from 'react-native';
import BottomSheet from 'shared/components/vxl/BottomSheet/BottomSheet';
import Button, { ButtonType } from 'shared/components/vxl/Button/Button';
import LoadingSpinner from 'shared/components/vxl/loading/LoadingSpinner/LoadingSpinner';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import TitleMdText from 'shared/components/vxl/typography/primary/title/TitleMdText';
import theme from 'shared/styles/theme';

export interface MaximumReachedBottomSheetProps {
  bottomSheetRef: RefObject<BottomSheetModal | null>;
  alertDetails?: {
    title?: string;
    message?: string;
    primaryButton?: {
      buttonStyle?: ButtonType;
      buttonText?: string;
    };
  };
  onSubmit: () => void;
  isLoading?: boolean;
}

const MaximumReachedBottomSheet = ({
  bottomSheetRef,
  alertDetails,
  onSubmit,
  isLoading = false,
}: MaximumReachedBottomSheetProps) => {
  const title = alertDetails?.title ?? '';
  const message = alertDetails?.message ?? '';
  const buttonText = alertDetails?.primaryButton?.buttonText ?? '';
  const buttonType: ButtonType =
    alertDetails?.primaryButton?.buttonStyle ?? 'PRIMARY';

  return (
    <BottomSheet
      ref={bottomSheetRef}
      contentContainerStyle={styles.bottomSheetContainer}
    >
      {isLoading ? (
        <View style={styles.loadingContainer}>
          <LoadingSpinner />
        </View>
      ) : (
        <>
          <View style={styles.contentContainer}>
            <TitleMdText numberOfLines={0}>{title}</TitleMdText>
            <BodyBaseText numberOfLines={0}>{message}</BodyBaseText>
          </View>

          <View style={styles.buttonContainer}>
            <Button onPress={onSubmit} label={buttonText} type={buttonType} />
          </View>
        </>
      )}
    </BottomSheet>
  );
};

const styles = StyleSheet.create({
  bottomSheetContainer: {
    paddingTop: 0,
  },
  buttonContainer: {
    flex: 1,
    padding: theme.spacing.m,
  },
  contentContainer: {
    flex: 1,
    gap: theme.spacing.s,
    padding: theme.spacing.m,
  },
  loadingContainer: {
    alignItems: 'center',
    flex: 1,
    padding: theme.spacing.m,
  },
});

export default MaximumReachedBottomSheet;
